import { FC, useEffect } from "react";
import { DialogData, DialogHandle } from "../../types";
import { useApp } from "../../context/useApp";
import { Icon } from "../../parts/Icon";
import { _, parseNum } from "../../utils/helpers";
import { APPLY_SURCHARGE_ENABLED, DEFAULT_DIALOG_HANDLE, SURCHARGE_NAME } from "../../utils/symbols";

interface SurchargeDialogProps {
    dialogData: DialogData
}

export const SurchargeDialog: FC<SurchargeDialogProps> = ({dialogData}) => {

    const {
        state: { dialogHandles, booking, tableMapHandle, products },
        actions: { genericError }
    } = useApp()

    if (dialogData.dialog !== 'surcharge') return null

    const dialogHandle:DialogHandle = dialogHandles.get('app-dialog') ?? DEFAULT_DIALOG_HANDLE

    const handleAcceptSurcharge = () => {
        if (!APPLY_SURCHARGE_ENABLED) {
            next()
        }
        const surcharge = products.find(product => product.name === SURCHARGE_NAME)
        if (!surcharge) {
            genericError(handleAcceptSurcharge)
            return
        }
        booking.applySurcharge(dialogData.surcharge, surcharge)
        next()
    }
    
    function next() {
        booking.setBookingStep('products').render()
        dialogHandle.closeDialog()

    }

    const handleSearchForIndividualTables = () => {

        if (booking.pax > 1) tableMapHandle.searchForDoubleTables()
        else tableMapHandle.searchForIndividualTables()
        booking.unselectTickets().render()
        dialogHandle.closeDialog()
    }

    return (
        <section
            className="df fd-c jcfs aic r3 section p-r py-10 px-13"
            aria-labelledby="dialog-title"
            aria-describedby="dialog-description"
        >
            <button 
                className="button b-0 p-2 p-a zi-6 close df aic jcc outline-shadow"
                onClick={() => dialogHandle.closeDialog()}
                aria-label={_('0ar_close__')}
                role="button"
            >
                <Icon icon="close" aria-hidden/>
            </button>
            <Icon icon="tickets" aria-hidden/>
            <h2 id="dialog-title" className="text s20-400 center mt-9 mb-6" aria-hidden>{_('3di_singl__')}</h2>
            <p id="dialog-description" className="text s60-500 center mb-7" aria-hidden>{`+${parseNum('EUR', dialogData.surcharge.amount)}`}</p>
            <div>
            <button
                role="option"
                className="button black px-10 py-7 r3 text s20-500 mb-7 w-100 b-0"
                onClick={handleAcceptSurcharge}
            >
                {_('3di_accep__')}
            </button>
            <button
                role="option"
                className="button px-10 py-7 r3 text s20-500 w-100 b-0 search-individual outline-shadow shadow"
                onClick={handleSearchForIndividualTables}
            >
                {_('0ge_reorg__')}
            </button>
            </div>
        </section>
    )
}